// Single analytics entry point. Every destination (GA4, Meta Pixel, Google Ads) is configured
// inside Google Tag Manager, so the app only ever pushes events onto the dataLayer.
// Build GTM triggers as: Trigger type "Custom Event" → the event name passed here.
export const trackEvent = (eventName, params = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...params });
};
